import React from "react";
import {useContext, useEffect, useState } from "react";
import { FichaContext } from "../../context/FichaContext";
import { block, unblock } from "../../helpers/loading";
import { axiosPublic } from "../../helpers/axios";

export const TerceraPagina = ( {setArreglo} ) => {
    const [Sistema, setSistema]=useState([]);
    const [Sedes, setSede]=useState([]);
    const [carrera, setCarrera]=useState([]);
    const [hiddenCarr2, setHiddenCarr2] = useState(true);
    const [hiddenCarr3, setHiddenCarr3] = useState(true);    
    const { data, setData } = useContext(FichaContext);
    const { tercera } = data;
    const { convocatoria } = data;
    const convoca = convocatoria.idconvocatoria
    const { sistema, sede, carrera1, carrera2, carrera3} = tercera;
    
    const handleInputChange=({target})=>{
        setData({
            ...data,
            tercera: {
                ...tercera,
                [target.name]: target.value
            }
        });
    }

    const handleInputChangeCentro=({target})=>{
        setSede([]);
        setCarrera([]);
        setData({
            ...data,
            tercera: {
                ...tercera,
                [target.name]: target.value,
                sede : '',
                carrera1 : '',
                carrera2 : '',
                carrera3 : ''
            }
        });
    }

    const handleInputChangeSede=({target})=>{
        setCarrera([]);
        setData({
            ...data,
            tercera: {
                ...tercera,
                [target.name]: target.value,
                carrera1 : '',
                carrera2 : '',
                carrera3 : ''
            }
        });
    }

    useEffect(()=>{
        block();
        axiosPublic(`centros/${convoca}`)
        .then(response => setSistema(response.data.centro))
        .catch(error => console.log(error));       
        unblock();
    },[convoca])

    useEffect(()=>{
       setHiddenCarr2(true);
       setHiddenCarr3(true);
       
        if (sistema){
            block();
            axiosPublic('sedes', {id_convocatoria:convoca, id_centro: sistema})
            .then(response => setSede(response.data.sedes))
            .catch(error => console.log(error));  
            unblock();
        }
    },[convoca, sistema])

    useEffect(()=>{
        if (sistema && sede){
            block();
            axiosPublic('sede_carreras', {id_convocatoria:convoca, id_centro: sistema, id_sede: sede})
            .then(response => setCarrera(response.data.carreras))
            .catch(error => console.log(error));
            unblock();
        }  
    },[convoca, sistema, sede]) 

    useEffect(()=>{
        setArreglo(carrera.length)
    },[carrera, setArreglo])
    
    useEffect(()=>{
        if(carrera.length === 2) {
            setHiddenCarr2(false)
            setHiddenCarr3(true);
        }
        if(carrera.length >= 3) {
            setHiddenCarr2(false);
            setHiddenCarr3(false);
        }
    },[ sede ,carrera])

return(
  
      <div className="cuerpo terc">
        <div className="titulo margintitulo"><legend className="card-header">SELECCIÓN DE SISTEMA, SEDE Y CARRERA</legend></div>
        
        <div className="formu">
              <div className="form-floating">
                  <select className="txtfloat form-select" value={sistema} onChange={handleInputChangeCentro} name="sistema" id="floatingSelect" >
                      <option disabled value={""}>Seleccionar...</option>
                      {Sistema.map(sistema => (  
                          <option key={sistema.id} value={sistema.id}>{sistema.etiqueta}</option>
                      ))}
                  </select>
                  <label className="lb">Sistema, centro, modalidad o programa:</label>
              </div>

              <div className="form-floating">
                  <select className="txtfloat form-select" onChange={handleInputChangeSede} name="sede" value={sede} id="floatingSelect">
                      <option  disabled value={""}>Seleccionar...</option>
                      {Sedes.map(sedes => (  
                          <option key={sedes.id} value={sedes.id}>{sedes.etiqueta}</option>
                      ))}
                  </select>
                  <label className="lb">Sede:</label>
              </div>
        </div>
        <div className="formu">
              <div className="form-floating">
                    <select className="txtfloat3 form-select" value={carrera1} id="floatingSelect" name="carrera1" onChange={handleInputChange}>
                        <option  disabled value={""}>Seleccionar...</option>
                        {carrera.map(carrera => (  
                            <option className="opcion" key={carrera.id} value={carrera.id}>{carrera.etiqueta}</option>
                        ))}
                    </select>
                    <label className="lb">Carrera primera opción:</label>
              </div>
              <div >
                  <div className="form-floating" >
                          <select className="txtfloat3 form-select" disabled={hiddenCarr2} value={carrera2} id="floatingSelect" name="carrera2" onChange={handleInputChange}>
                           <option  disabled value={""}>Seleccionar...</option>
                              {carrera.map(carrera => (  
                                  <option className="opcion" key={carrera.id} value={carrera.id}>{carrera.etiqueta}</option>
                              ))}
                          </select>
                          <label className="lb" disabled={hiddenCarr2}>Carrera segunda opción:</label>   
                  </div>
                  {((carrera2 === carrera1 ) && carrera1 !== "") && <i className="val">Esta carrera ya fue selecionada</i>}
              </div>
              <div>
                  <div className="form-floating" >
                          <select className="txtfloat3 form-select" disabled={hiddenCarr3} value={carrera3} id="floatingSelect" name="carrera3" onChange={handleInputChange}>
                              <option  disabled value={""}>Seleccionar...</option>
                              {carrera.map(carrera => (  
                                  <option className="opcion" key={carrera.id} value={carrera.id}>{carrera.etiqueta}</option>
                              ))}
                          </select>
                          <label className="lb" disabled={hiddenCarr3}>Carrera tercera opción:</label>
                  </div>
                  {((carrera3 === carrera1 || carrera2 === carrera3) && (carrera1 !== "" && carrera2 !== "")) && <i className="val">Esta carrera ya fue selecionada</i>}
              </div>
        </div>   
        </div>
      
  
);
}
